<template>
  <div>
    <b-breadcrumb :items="crumbLinks"></b-breadcrumb>
    <div class="flex text-left p-2">
      <h1 class="header">Site Map</h1>
      <p v-if="loadFailed">
        Cannot load the site map. Please try again later or contact
        <a href="mailto:curator@arabidopsis.org">curator@arabidopsis.org</a>.
      </p>
      <template v-else-if="siteMap">
        <p>{{ siteMap.description }}</p>
        <section v-for="section in siteMap.sections" :key="section.title">
          <h2 class="section-header">{{ section.title }}</h2>
          <p v-if="section.description">{{ section.description }}</p>
          <dl>
            <template v-for="entry in section.entries">
              <dt :key="`${entry.title}-title`">
                <span v-if="hasPlaceholder(entry.address)">{{ entry.title }}</span>
                <a v-else-if="isOnAnotherSite(entry.address)" :href="entry.address">{{ entry.title }}</a>
                <router-link v-else :to="entry.address">{{ entry.title }}</router-link>
                <span v-if="entry.subscriptionRequired" class="subscription">
                  Subscription required
                </span>
              </dt>
              <dd :key="`${entry.title}-description`">
                <p>{{ entry.description }}</p>
              </dd>
            </template>
          </dl>
        </section>
      </template>
    </div>
  </div>
</template>

<script>
import {getSiteMap} from "@/services/SiteMapService";

export default {
    name: "SiteMap",

    data () {
        return {
            siteMap: null,
            loadFailed: false,
            crumbLinks: [
                {
                    text: "Home",
                    href: "/"
                },
                {
                    text: "Site Map",
                    active: true
                }
            ]
        };
    },

    async mounted () {
        try {
            const siteMap = await getSiteMap();

            if (!Array.isArray(siteMap.sections)) {
                throw new Error("site map response has no sections");
            }

            this.siteMap = siteMap;
        } catch (error) {
            console.error("Could not load the site map", error);
            this.loadFailed = true;
        }
    },

    methods: {
        hasPlaceholder (address) {
            return address.includes("{");
        },

        isOnAnotherSite (address) {
            return /^https?:\/\//.test(address);
        }
    }
};
</script>

<style scoped lang="scss">
.header {
  color: #0c335d;
  margin-bottom: 1rem;
  font-size: 2rem;
  font-weight: bold;
}

.section-header {
  color: #0c335d;
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: bold;
}

.flex {
  max-width: 1200px;
  margin: 0 auto;
}

p {
  margin-bottom: 1rem;
  line-height: 1.6;
}

a {
  color: #0c335d;
  text-decoration: underline;
  &:hover {
    color: #0a2a4a;
  }
}

dt {
  font-size: 1.1rem;
}

dd {
  margin-left: 1.5rem;
  margin-bottom: 1.25rem;
  p {
    margin-bottom: 0.25rem;
  }
}

.subscription {
  margin-left: 0.5rem;
  font-size: 0.85rem;
  font-weight: normal;
  font-style: italic;
}

.breadcrumb {
  padding: 10px 0 10px 1rem;
  font-weight: bold;
  font-size: 18px;
}
</style>
